import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import { DateTime, Combobox, Input, RadioGroup } from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

function Relalteracaoestoqueproduto() {
  const [open, setOpen] = useState(true);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsUser = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  function handleSerializeForm(params) {
    return {
      ...params,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.alteracaoestoqueproduto')}
      relatorio="alteracaoestoqueproduto"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <Combobox
        name="idposto"
        label="nomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.menu.configuracao.posto')}
        first={[{ label: 'TODOS', value: '' }]}
        defaultValue=""
        hiddens={[{ name: 'nomeposto' }]}
      />

      <Combobox
        name="idproduto"
        label="nomeabreviadoproduto"
        url="produtos"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        first={[{ label: 'TODOS', value: '' }]}
        defaultValue=""
        hiddens={[{ name: 'nomeabreviadoproduto' }]}
      />

      <PesquisaTabela
        name="codigousuario"
        label={t('s.relatorio.alteracaoestoqueproduto.usuario')}
        primary="codigousuario"
        secondary="nomeusuario"
        url="usuarios"
        header={cellsUser}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relalteracaoestoqueproduto;
